import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/images/RLBGR.webp";

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isHomeOpen, setHomeOpen] = useState(false);
  const [isPagesOpen, setPagesOpen] = useState(false);
  const [isProjectsOpen, setProjectsOpen] = useState(false);
  const [isServicesOpen, setServicesOpen] = useState(false);

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setHomeOpen(false);
    setPagesOpen(false);
    setProjectsOpen(false);
    setServicesOpen(false);
  };

  // Toggle individual dropdowns
  const toggleHomeDropdown = (e) => {
    e.stopPropagation();
    setHomeOpen(!isHomeOpen);
  };

  const togglePagesDropdown = (e) => {
    e.stopPropagation();
    setPagesOpen(!isPagesOpen);
  };

  const toggleServicesDropdown = (e) => {
    e.stopPropagation();
    setServicesOpen(!isServicesOpen);
  };

  // JavaScript function to close dropdowns when clicking outside
  const closeDropdowns = (e) => {
    if (!e.target.closest(".dropdown")) {
      setHomeOpen(false);
      setPagesOpen(false);
      setProjectsOpen(false);
      setServicesOpen(false);
    }
  };

  // Add event listener to close dropdowns when clicking outside
  React.useEffect(() => {
    document.addEventListener("click", closeDropdowns);
    return () => {
      document.removeEventListener("click", closeDropdowns);
    };
  }, []);

  return (
    <header className="header">
      {/* Top Bar */}
        <div className="w-full bg-[#87212e] text-white h-20">
          <div className="container mx-auto h-full">
            <div className="flex items-center justify-center w-full h-full">
          <div className="text-center">
            <p className="font-['Outfit'] text-xs xs:text-sm sm:text-base m-0 leading-none">
              Building today for a sustainable tomorrow.
            </p>
          </div>
            </div>
          </div>
        </div>

        {/* Navigation Bar */}
      <div className={`nav-bar ${isMobileMenuOpen ? "active" : ""}`}>
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="Ray" />
          </Link>
        </div>

        <nav className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
          <div className="dropdown">
            <button className="dropbtn" onClick={toggleHomeDropdown}>
              <Link to="/" onClick={closeMobileMenu}>Home</Link>
            </button>
          </div>

          <div className="dropdown">
            <button className="dropbtn" onClick={toggleHomeDropdown}>
              <Link to="/Breakthrough" onClick={closeMobileMenu}>Careers</Link>
            </button>
          </div>

          <div className="dropdown">
            <button className="dropbtn" onClick={togglePagesDropdown}>
              About Us
            </button>
            {isPagesOpen && (
              <div className="dropdown-content">
                <Link to="/Breakthrough" onClick={closeMobileMenu}>History</Link>
                <Link to="/Leadership" onClick={closeMobileMenu}>Our Team</Link>
                <Link to="/FAQ" onClick={closeMobileMenu}>FAQ</Link>
                <Link to="/Brochures" onClick={closeMobileMenu}>Brochures</Link>
              </div>
            )}
          </div>

          <div className="dropdown">
            <button className="dropbtn" onClick={toggleServicesDropdown}>
              Services
            </button>
            {isServicesOpen && (
              <div className="dropdown-content">
                <Link to="/ServicePage" onClick={closeMobileMenu}>Services</Link>
                <Link to="/RecentProject" onClick={closeMobileMenu}>Recent Projects</Link>
              </div>
            )}
          </div>

          <Link to="/contact" className="contact-btnX" onClick={closeMobileMenu}>
            Contact Us
          </Link>
        </nav>

        <div className="hamburger" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;